import { logger } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../..';
import type { StoreWithSetter } from '../types';

type IsDirectlyChosenIndustry = boolean;

export type TrackingIndustries = {
    [industry: string]: IsDirectlyChosenIndustry;
};

type RelatedIndustries = Record<
    MIXPANEL_EVENT_PROPERTIES.RELATED_INDUSTRY_COUNT,
    number | undefined
>;

type Options = {
    disableErrorLogging: boolean;
};

const { RELATED_INDUSTRY_COUNT } = MIXPANEL_EVENT_PROPERTIES;

const getRelatedIndustries = (trackingIndustries: TrackingIndustries) => ({
    [RELATED_INDUSTRY_COUNT]: trackingIndustries
        ? Object.keys(trackingIndustries).filter(
              (key) => !trackingIndustries[key]
          ).length
        : undefined,
});

export class RelatedIndustriesStore
    implements
        StoreWithSetter<TrackingIndustries, RelatedIndustries | undefined>
{
    private _relatedIndustries?: RelatedIndustries;

    private disableErrorLogging = false;

    private _trackingIndustries?: TrackingIndustries;

    constructor(
        { disableErrorLogging = false }: Options = {
            disableErrorLogging: false,
        }
    ) {
        this.disableErrorLogging = disableErrorLogging;
    }

    public getRawData = () => this._trackingIndustries;

    public setData = (trackingIndustries: TrackingIndustries) => {
        this._trackingIndustries = trackingIndustries;
        this._relatedIndustries = getRelatedIndustries(trackingIndustries);
    };

    public getData = () => {
        if (!this._relatedIndustries && !this.disableErrorLogging) {
            const error = new Error('No relatedIndustries was set');
            logger.error(error);
        }

        return this._relatedIndustries;
    };
}
